import React, { useState, useEffect } from "react";
import InputField from "../../UIComponents/Input/Input";
import { Button, Checkbox, Modal } from "antd";
import "./LandingPage";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import rightIcon from "../../images/correct-Icon.png";
import errorIcon from "../../images/error-icon.png";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { pincodeData } from "../RbiForm/rbiData";
import { setAddress, setEmpId } from "../../redux/actions/rbi";
import { baseUrl } from "../../utils/Helper";
import SingleSelect from "../../UIComponents/Select/SingleSelect";

const serviceData = [
  { id: "Serving Employee", name: "Serving Employee" },
  { id: "Retired Employee", name: "Retired Employee" },
];

const genderData = [
  { id: "Male", name: "Male" },
  { id: "Female", name: "Female" },
  { id: "Others", name: "Others" },
];

const CdoForm = () => {
  const history = useHistory();
  //   const [service, setService] = useState("");
  const [service, setService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isTcModalOpen, setIsTcModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pincodedata, setPincodeData] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isCheked, setIsChecked] = useState(null);
  //   const [genderdata, setGenderdata] = useState("");
  const [genderdata, setGenderdata] = useState(null);
  const [patientData, setPatientData] = useState(null);

  let url = baseUrl();

  const mobileNumber = useSelector((state) => state?.rbi?.number);

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    employeeId: "",
    alternatePhone: "",
    currentAddress: "",
    pincode: "",
    dob: "",
    email: "",
  });
  const [errors, setErrors] = useState({});

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleErrorOk = () => {
    setIsErrorModalOpen(false);
  };
  const handleTcOk = () => {
    setIsTcModalOpen(false);
  };

  const handleDone = () => {
    history.push("/yajivmar");
  };

  const [error, setError] = useState("");
  const handleChangePincode = (value) => {
    setPincodeData(value.toString());
    if (value) {
      setError(""); // Clear error if a service is selected
    }
  };

  const handleChangeService = (value) => {
    setService(value.toString());
    if (value) {
      setError(""); // Clear error if a service is selected
    }
  };

  const onChange = (e) => {
    setIsChecked(e.target.checked);
    setIsTcModalOpen(e.target.checked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "currentAddress") {
      dispatch(setAddress(value));
    }

    if (name === "pincode") {
      // Allow only digits and limit to 6 characters
      if (/^\d{0,6}$/.test(value)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
      return; // Prevent other logic from running for pincode
    }

    if (name === "alternatePhone") {
      // Allow only digits and limit to a maximum of 10 digits
      if (/^\d{0,10}$/.test(value)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value, // Trim the value to 10 digits if it exceeds the limit
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    // if (name === "employeeId") {
    //   if (/^\d{0,6}$/.test(value)) {
    //     setFormData((prevData) => ({
    //     ...prevData,
    //       [name]: value,
    //     }));
    //   } else if (/^[a-zA-Z][a-zA-Z0-9]{0,9}$/.test(value)) {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       [name]: value,
    //     }));
    //   }
    //   dispatch(setEmpId(value));
    // } else {
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     [name]: value,
    //   }));
    // }

    if (name === "employeeId") {
      const isValid = /^[a-zA-Z0-9]*$/.test(value);

      if (!isValid) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          employeeId: "Special characters not allowed",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          employeeId: "",
        }));
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        dispatch(setEmpId(value));
      }
    }

    if (value === "") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      return;
    }
  };
  const handleChange1 = (e) => {
    const { name, value } = e.target;

    // Allow only digits and limit to a maximum of 10 digits
    if (/^\d{0,10}$/.test(value)) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value, // Trim the value to 10 digits if it exceeds the limit
      }));
    }
  };

  const formatForInputField = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${year}-${month}-${day}`; // yyyy-mm-dd format for InputField
  };

  const dateString = patientData?.data?.members?.[0]?.dob;
  const inputFormattedDate = formatForInputField(dateString); // Use this format for input field

  const validateForm = () => {
    let validationErrors = {};

    if (!formData.name) {
      validationErrors.name = "Name is required";
    }
    if (!formData.dob && !inputFormattedDate) {
      validationErrors.dob = "DOB is required";
    }

    if (!formData.employeeId) {
      validationErrors.employeeId = "Employee ID is required";
    } else if (!/^[a-zA-Z0-9]*$/.test(formData.employeeId)) {
      validationErrors.employeeId = "Special characters not allowed";
    }

    // if (!formData.currentAddress && !patientData?.data?.address?.address1) {
    //   validationErrors.currentAddress = "Current Address is required";
    // }

    // if (!genderdata && !patientData?.data?.members?.[0]?.gender) {
    //   validationErrors.genderdata = "Please select gender";
    // }

    // if (!pincodedata && !patientData?.data?.address?.pincode) {
    // validationErrors.pincodedata = "Please select pincode";

    // }
    if (!formData.pincode) {
      // validationErrors.pincode = "pincode cannot be empty";
    } else if (formData.pincode.length !== 6) {
      validationErrors.pincode = "pincode must be 6 digits";
    }
    if (!service && !patientData?.data?.designation) {
      validationErrors.service = "Please select service";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (validateForm()) {
      const employeeData = {
        name: formData.name,
        designation: service,
        employeeId: formData.employeeId,
        email: formData.email,
        address: {
          address1: formData.currentAddress,
          city: "Mumbai",
          state: "Maharashtra",
          pincode: formData.pincode,
          country: "India",
        },
        mobile: mobileNumber,
        gender: genderdata,
        dob: formData?.dob.split("-").reverse().join("/"),
      };

      try {
        setIsSubmitting(true);

        const response = await axios.post(
          `${url}user/uco/add-patient`,
          employeeData,
          {
            headers: {
              "Content-Type": "application/json",
              Credential: true,
            },
          }
        );

        console.log("response", response);

        if (response.status === 201) {
          setSuccessMessage(response?.data?.message);
          setIsModalOpen(true);
        } else {
        }
      } catch (error) {
        setIsErrorModalOpen(true); // Show error modal on network error
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const emp = queryParams.get("emply");

  const handleGender = (value) => {
    setGenderdata(value.toString() || patientData?.data?.members?.[0]?.gender);
    if (value) {
      setError(""); // Clear error if a service is selected
    }
  };

  return (
    <div>
      <div className="rbi-main-content">
        <div className="login-content">
          <div className="login-text">
            <div className="login-input">
              <p>
                Name <span style={{ color: "red" }}>*</span>
              </p>
              <InputField
                type="text"
                maxLength={35}
                id="name"
                name="name"
                placeholder="Enter Your Name"
                className="phone-input-style1"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>
            <div className="login-input">
              <p>
                {" "}
                Employee ID <span style={{ color: "red" }}>*</span>
              </p>
              <InputField
                type="text"
                id="employeeId"
                name="employeeId"
                placeholder="Enter Your Employee ID"
                className="phone-input-style1"
                value={formData.employeeId}
                onChange={handleChange}
              />
              {errors.employeeId && (
                <span className="error">{errors.employeeId}</span>
              )}
            </div>
            <div className="login-input">
              <p>
                Employee Status <span style={{ color: "red" }}>*</span>
              </p>

              <SingleSelect
                data={serviceData}
                onChange={handleChangeService}
                value={service}
                placeholder="Select Service"
                id="service"
              />
              {errors.service && (
                <span className="error">{errors.service}</span>
              )}
            </div>

            <div className="login-input">
              <p>Date of Birth </p>
              <InputField
                value={formData.dob}
                onChange={handleChange}
                type="date"
                maxLength={35}
                name="dob"
                id="dob"
                placeholder="Enter dob"
                className="phone-input-style1"
                // disabled={inputFormattedDate}
              />
            </div>

            <div className="login-input">
              <p>Gender</p>

              <SingleSelect
                data={genderData}
                onChange={handleGender}
                value={genderdata}
                placeholder="Select Gender"
                id="gender"
              />
            </div>

            <div className="login-input">
              <p>Email</p>
              <InputField
                type="email"
                maxLength={35}
                id="email"
                name="email"
                placeholder="Enter Your Email"
                className="phone-input-style1"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="login-input">
              <p>Current Address</p>
              <InputField
                type="text"
                id="currentAddress"
                name="currentAddress"
                placeholder="Enter Your Current Address"
                className="phone-input-style1"
                value={formData.currentAddress}
                onChange={handleChange}
              />
              {errors.currentAddress && (
                <span className="error">{errors.currentAddress}</span>
              )}
            </div>
            <div className="login-input">
              <p>Pincode</p>
              {/* <SingleSelect
                data={pincodeData}
                onChange={handleChangePincode}
                value={pincodedata}
                placeholder="Enter Pincode"
                id="pincode"
              /> */}

              <InputField
                type="text"
                id="pincode"
                name="pincode"
                placeholder="Enter Your pincode"
                className="phone-input-style1"
                value={formData.pincode}
                onChange={handleChange}
                maxLength={6}
                inputMode="numeric"
                pattern="\d*"
              />
              {errors.pincode && (
                <span className="error">{errors.pincode}</span>
              )}
            </div>
            <div className="login-input">
              <p>Nearest Pharmacy</p>
              <InputField
                type="text"
                maxLength={35}
                id="pharmacy"
                name="pharmacy"
                placeholder="Enter pharmacy"
                className="phone-input-style1"
                value={formData.pharmacy}
                onChange={handleChange}
              />
              {errors.pharmacy && (
                <span className="error">{errors.pharmacy}</span>
              )}
            </div>
            {/* <div style={{ paddingTop: "10px" }}>
                <Checkbox onChange={onChange}>
                  I agree to the Terms & Conditions
                </Checkbox>
              </div> */}
            <div className="login-btn-section" style={{ paddingTop: "15px" }}>
              <Button
                className="login-btn"
                onClick={handleSubmit}
                loading={isSubmitting}
                //   disabled={isCheked ? false : true}
                disabled={!formData?.employeeId || !formData?.name || !service}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <Modal
        visible={isModalOpen}
        onOk={handleOk}
        width={210}
        onCancel={handleCancel}
        // closeIcon={<span style={{ fontSize: "16px" }}>✖</span>}
        closable={false}
        style={{ top: "50%", transform: "translateY(-50%)" }}
        maskClosable={false}
      >
        <div style={{ padding: "5px", textAlign: "center" }}>
          <div>
            <img
              className="user-icon-header"
              width={80}
              src={rightIcon}
              alt="user-icon"
            />
          </div>
          <h5>{successMessage}</h5>
          <Button className="done-btn" onClick={handleDone}>
            Done
          </Button>
        </div>
      </Modal>

      {/* Error Modal */}
      <Modal
        visible={isErrorModalOpen}
        onOk={handleErrorOk}
        onCancel={handleErrorOk}
        closable={false}
        style={{ top: "50%", transform: "translateY(-50%)" }}
        maskClosable={false}
        width={250}
      >
        <div style={{ padding: "5px", textAlign: "center" }}>
          <div>
            <img
              className="user-icon-header"
              width={80}
              src={errorIcon}
              alt="user-icon"
            />
          </div>
          {/* <h5>There was an error submitting the form. Please try again.</h5> */}
          <h5>Employee Id already exists.</h5>
          <Button className="done-btn" onClick={handleErrorOk}>
            Close
          </Button>
        </div>
      </Modal>
      {/* tc Modal */}
      <Modal
        visible={isTcModalOpen}
        onOk={handleTcOk}
        onCancel={handleTcOk}
        closable={false}
        style={{ top: "50%", transform: "translateY(-50%)" }}
        maskClosable={false}
      >
        <div style={{ padding: "5px" }}>
          <h5>
            <p>
              {" "}
              1. I want to avail home delivery of Medicines on credit slip from
              Apollo Pharmacies Ltd.{" "}
            </p>
            <p>
              2. I understand that the details that I furnish here will be
              shared with Apollo Pharmacies Ltd and outside the Bank. I agree
              that I give my consent for sharing this information.
            </p>
            <p>
              3. I want the eligible medicines to be issued under the credit
              slip facility.
            </p>
            <p>
              4. I submit that I will avail medicines only for personal use of
              self and eligible dependents.
            </p>
            <p>
              5. I will check the medicines for expiry date and provide
              appropriate confirmation at the time of delivery, including
              handing over the Prescription slip.
            </p>
          </h5>
          <div style={{ textAlign: "center" }}>
            <Button className="done-btn" onClick={handleTcOk}>
              OK
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CdoForm;
